import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

const AVATAR_BACKGROUND_COLORS = [
  '#0d47a1',
  '#1b5e20',
  '#4a148c',
  '#b71c1c',
  '#004d40',
  '#3e2723',
  '#263238',
  '#880e4f',
];

@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProfileHeaderComponent {
  @Input() avatarPath?: string | null;
  @Input() firstName?: string | null;
  @Input() lastName?: string | null;
  @Input() email?: string | null;
  @Output() avatarSelected = new EventEmitter<Event>();

  protected get avatarInitials(): string {
    const firstName = this.firstName?.trim();
    const lastName = this.lastName?.trim();

    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }

    return this.email?.trim().slice(0, 2).toUpperCase() ?? '';
  }

  protected get avatarBackgroundColor(): string {
    const name = `${this.firstName ?? ''} ${this.lastName ?? ''}`;
    const hash = Array.from(name).reduce(
      (value, character) => character.charCodeAt(0) + ((value << 5) - value),
      0,
    );

    return AVATAR_BACKGROUND_COLORS[
      Math.abs(hash) % AVATAR_BACKGROUND_COLORS.length
    ];
  }

  onAvatarSelected(event: Event): void {
    this.avatarSelected.emit(event);
  }
}
